export default "__VITE_ASSET__SlBOyxDq__"